var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 mb-4 rounded-lg bg-blue-50"},[_c('div',{staticClass:"flex items-center gap-3"},[_c('Icon',{staticClass:"text-blue-900",attrs:{"icon":['far', 'info-circle']}}),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-0 text-sm text-blue-900"},[_vm._t("default")],2)]),_vm._v(" "),_vm._t("additional-content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }